import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Lock } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { PayDebtAction } from "@/components/Molecules";
import type { CommissionLockedStateProps } from "./CommissionLockedState.types";
import * as styles from "./CommissionLockedState.styles";

export type { CommissionLockedStateProps } from "./CommissionLockedState.types";

export const CommissionLockedState = memo(function CommissionLockedState({
  canPayDebt,
  showDataSafeNote = true,
  compact = false,
}: CommissionLockedStateProps) {
  const { t } = useTranslation("commission");
  const theme = useTheme();

  return (
    <Box sx={styles.root(compact)}>
      <Box sx={styles.iconWrap(compact)}>
        <Lock size={compact ? 32 : 52} variant="Bold" color={theme.palette.text.secondary} />
      </Box>
      <Typography sx={styles.title}>{t("locked.title")}</Typography>
      <Typography sx={styles.description}>{t("locked.description")}</Typography>
      {showDataSafeNote ? <Typography sx={styles.dataSafeText}>{t("dataSafe")}</Typography> : null}
      <Box sx={styles.actionWrap}>
        <PayDebtAction canPayDebt={canPayDebt} />
      </Box>
    </Box>
  );
});
